import React from 'react'
import { StarChartItemDeletePresentationProps } from '../../types/types'
import { StarChartOrgCloseIcon, StarChartOrgDialogStyle, StarChartOrgFormCol, StarChartOrgItemDeleteDesc, StarChartOrgItemDeleteTitle } from './StarChartOrgItemDeletePresentation.style'
import { DialogContent } from '@mui/material'
import { CancelButton, CancelButtonText, DeleteButton, DeleteButtonText } from '../../../../assets/style/General.style'

import { images } from '../../../../constants'


const StarChartOrgItemDeletePresentation: React.FC<StarChartItemDeletePresentationProps> = ({starChartDelete , closeDeletePopup , starChartName}) => {

  return (
    <StarChartOrgDialogStyle
    open={starChartDelete}
    onClose={closeDeletePopup}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogContent sx={{ width: '500px', padding: '24px' }}>

        <StarChartOrgCloseIcon
            onClick={closeDeletePopup}
            src={images.closeIconSimple}
                            
        />
        <StarChartOrgFormCol alignment="flex-start" Direction={'column'}>
                <StarChartOrgItemDeleteTitle>Detele StarChart</StarChartOrgItemDeleteTitle>
                <StarChartOrgItemDeleteDesc style={{paddingBottom:15}}>Are you sure you want to delete {starChartName} StarChart?</StarChartOrgItemDeleteDesc>
                <StarChartOrgItemDeleteDesc>Students and Organizations have this StarChart assigned. If you delete it they will lose all permissions on it and won’t see the experiences related.</StarChartOrgItemDeleteDesc>
        </StarChartOrgFormCol>
        <StarChartOrgFormCol alignment="flex-end" Direction={'row'} style={{width:"100%", paddingTop:15}}>
                  
                        <CancelButton
                          style={{ marginLeft: '15px', width: '60px' }}
                          onClick={closeDeletePopup}
                        >
                          <CancelButtonText >Cancel</CancelButtonText>
            
                          
                        </CancelButton>
            
            
            
                        <DeleteButton
                          style={{ marginLeft: '9px' }}
                          onClick={()=>{}}
                        >
                          <DeleteButtonText>Delete</DeleteButtonText>
            
                          
                        </DeleteButton>
        </StarChartOrgFormCol>


      </DialogContent>
    </StarChartOrgDialogStyle>


  )
}

export default StarChartOrgItemDeletePresentation